<template>
  <div class="table1">
    <div class="table1_top_fixed" style="background-color: #fff">
      <div class="table1_top_fixed_left">股票</div>
      <div class="table1_top_fixed_right">
        <div class="table1_top_fixed_menu" style="width: 90px">
          最新收盘价
          <div>
            <img
              src="../../../../public/img/IndexValuation/table_down_up.png"
              alt=""
            />
          </div>
        </div>
        <div class="table1_top_fixed_menu">
          PE
          <div>
            <img
              src="../../../../public/img/IndexValuation/table_down_up.png"
              alt=""
            />
          </div>
        </div>
        <div class="table1_top_fixed_menu">
          PE分位
          <div>
            <img
              src="../../../../public/img/IndexValuation/table_down_up.png"
              alt=""
            />
          </div>
        </div>
        <div class="table1_top_fixed_menu">
          PB
          <div>
            <img
              src="../../../../public/img/IndexValuation/table_down_up.png"
              alt=""
            />
          </div>
        </div>
        <div class="table1_top_fixed_menu">
          PB分位
          <div>
            <img
              src="../../../../public/img/IndexValuation/table_down_up.png"
              alt=""
            />
          </div>
        </div>
        <div class="table1_top_fixed_menu">
          ROE
          <div>
            <img
              src="../../../../public/img/IndexValuation/table_down_up.png"
              alt=""
            />
          </div>
        </div>
        <div class="table1_top_fixed_menu">
          股息率
          <div>
            <img
              src="../../../../public/img/IndexValuation/table_down_up.png"
              alt=""
            />
          </div>
        </div>
        <div class="table1_top_fixed_menu">
          RPS10
          <div>
            <img
              src="../../../../public/img/IndexValuation/table_down_up.png"
              alt=""
            />
          </div>
        </div>
        <div class="table1_top_fixed_menu">
          RPS20
          <div>
            <img
              src="../../../../public/img/IndexValuation/table_down_up.png"
              alt=""
            />
          </div>
        </div>
        <div class="table1_top_fixed_menu">
          RPS60
          <div>
            <img
              src="../../../../public/img/IndexValuation/table_down_up.png"
              alt=""
            />
          </div>
        </div>
        <div class="table1_top_fixed_menu">
          RPS120
          <div>
            <img
              src="../../../../public/img/IndexValuation/table_down_up.png"
              alt=""
            />
          </div>
        </div>
        <div class="table1_top_fixed_menu">
          RPS250
          <div>
            <img
              src="../../../../public/img/IndexValuation/table_down_up.png"
              alt=""
            />
          </div>
        </div>
        <div class="table1_top_fixed_menu">
          近1月
          <div>
            <img
              src="../../../../public/img/IndexValuation/table_down_up.png"
              alt=""
            />
          </div>
        </div>
        <div class="table1_top_fixed_menu">
          近3月
          <div>
            <img
              src="../../../../public/img/IndexValuation/table_down_up.png"
              alt=""
            />
          </div>
        </div>
        <div class="table1_top_fixed_menu">
          近6月
          <div>
            <img
              src="../../../../public/img/IndexValuation/table_down_up.png"
              alt=""
            />
          </div>
        </div>
        <div class="table1_top_fixed_menu">
          近1年
          <div>
            <img
              src="../../../../public/img/IndexValuation/table_down_up.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="table1_content">
      <div
        style="display: flex; border-bottom: 1px solid rgba(223, 223, 223, 0.3)"
      >
        <div class="table1_top_fixed_left">股票</div>
        <div class="table1_top_fixed_right">
          <div class="table1_top_fixed_menu" style="width: 90px"></div>
          <div class="table1_top_fixed_menu"></div>
          <div class="table1_top_fixed_menu"></div>
          <div class="table1_top_fixed_menu"></div>
          <div class="table1_top_fixed_menu"></div>
          <div class="table1_top_fixed_menu"></div>
          <div class="table1_top_fixed_menu"></div>
          <div class="table1_top_fixed_menu"></div>
          <div class="table1_top_fixed_menu"></div>
          <div class="table1_top_fixed_menu"></div>
          <div class="table1_top_fixed_menu"></div>
          <div class="table1_top_fixed_menu"></div>
          <div class="table1_top_fixed_menu"></div>
          <div class="table1_top_fixed_menu"></div>
          <div class="table1_top_fixed_menu"></div>
          <div class="table1_top_fixed_menu"></div>
        </div>
      </div>
      <div
        style="display: flex; border-bottom: 1px solid rgba(223, 223, 223, 0.3)"
        v-for="(item, index) in table_data_list"
        :key="index"
      >
        <div class="table1_top_fixed_left2">
          <div class="table1_top_fixed_left2_name">123</div>
          <div class="table1_top_fixed_left2_code">
            <div class="table1_top_fixed_left2_code_text1 guzhi_type1">
              估值偏低
            </div>
            <div class="table1_top_fixed_left2_code_text2">000001</div>
          </div>
        </div>
        <div class="table1_top_fixed_right">
          <div class="table1_top_fixed_menu2" style="width: 90px">{{item.a}}</div>
          <div class="table1_top_fixed_menu2">{{item.b}}</div>
          <div class="table1_top_fixed_menu2">{{item.c}}</div>
          <div class="table1_top_fixed_menu2">47.32</div>
          <div class="table1_top_fixed_menu2">123</div>
          <div class="table1_top_fixed_menu2">456</div>
          <div class="table1_top_fixed_menu2">789</div>
          <div class="table1_top_fixed_menu2">11.22</div>
          <div class="table1_top_fixed_menu2">22.33</div>
          <div class="table1_top_fixed_menu2">33.44</div>
          <div class="table1_top_fixed_menu2">44.55</div>
          <div class="table1_top_fixed_menu2">55.66</div>
          <div class="table1_top_fixed_menu2">66.77</div>
          <div class="table1_top_fixed_menu2">77.88</div>
          <div class="table1_top_fixed_menu2">88.99</div>
          <div class="table1_top_fixed_menu2">100</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      table_data_list: [
        {
          a: 18.2,
          b: 36.5,
          c: 89.65,
        },
        {
          a: 18.2,
          b: 36.5,
          c: 89.65,
        },
        {
          a: 18.2,
          b: 36.5,
          c: 89.65,
        },
        {
          a: 18.2,
          b: 36.5,
          c: 89.65,
        },
        {
          a: 18.2,
          b: 36.5,
          c: 89.65,
        },
        {
          a: 18.2,
          b: 36.5,
          c: 89.65,
        },
        {
          a: 18.2,
          b: 36.5,
          c: 89.65,
        },
        {
          a: 18.2,
          b: 36.5,
          c: 89.65,
        },
        {
          a: 18.2,
          b: 36.5,
          c: 89.65,
        },
        {
          a: 18.2,
          b: 36.5,
          c: 89.65,
        },
        {
          a: 18.2,
          b: 36.5,
          c: 89.65,
        },
        {
          a: 18.2,
          b: 36.5,
          c: 89.65,
        },
        {
          a: 18.2,
          b: 36.5,
          c: 89.65,
        },
        {
          a: 18.2,
          b: 36.5,
          c: 89.65,
        },
        {
          a: 18.2,
          b: 36.5,
          c: 89.65,
        },
        {
          a: 18.2,
          b: 36.5,
          c: 89.65,
        },
        {
          a: 18.2,
          b: 36.5,
          c: 89.65,
        },
      ],
    };
  },
};
</script>

<style scoped>
.table1 {
  position: relative;
}
.table1_top_fixed {
  position: absolute;
  top: 0;
  display: flex;
  border-bottom: 1px solid rgba(223, 223, 223, 0.3);
}
.table1_top_fixed_right,
.table1_top_fixed_left {
  display: flex;
  height: 40px;
  line-height: 40px;
}
.table1_top_fixed_left {
  width: 100px;
  font-size: 14px;
  color: #000000;
  padding-left: 17px;
}
.table1_top_fixed_left2 {
  display: flex;
  flex-direction: column;
  height: 46px;
  padding: 15px 0 13px 0;
}
.table1_top_fixed_left2 {
  width: 120px;
  font-size: 14px;
  color: #000000;
}
.table1_top_fixed_left2_name {
  font-size: 16px;
  color: #000000;
  margin-bottom: 5px;
}
.table1_top_fixed_left2_code {
  display: flex;
}
.table1_top_fixed_left2_code_text1 {
  width: 54px;
  height: 18px;
  text-align: center;
  line-height: 18px;
  font-size: 12px;
  color: #ffffff;
  border-radius: 3px;
}
.table1_top_fixed_left2_code_text2 {
  font-size: 14px;
  color: #000000;
  margin-left: 5px;
}
.table1_top_fixed_menu {
  display: flex;
  align-content: center;
  height: 40px;
  line-height: 40px;
  min-width: 80px;
  font-size: 14px;
  color: #666666;
  justify-content: flex-end;
  cursor: pointer;
}
.table1_top_fixed_menu img {
  width: 8px;
  height: 14px;
  vertical-align: middle;
  margin-left: 6px;
}
.table1_top_fixed_menu2 {
  display: flex;
  align-content: center;
  height: 75px;
  line-height: 75px;
  min-width: 80px;
  font-size: 14px;
  color: #666666;
  justify-content: center;
  cursor: pointer;
}
.table1_top_fixed_menu2 img {
  width: 8px;
  height: 14px;
  vertical-align: middle;
  margin-left: 6px;
}
.table1_content {
  height: 500px;
  overflow-y: scroll;
}
.guzhi_type1 {
  background-color: #3cbb73;
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
</style>